(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["corner-beads-nav-review"] && !Shopify.designMode) return;
  try {
    (() => {
  const stateKey = 'cornerBrowse';
  const storageKey = 'corner:browse:v1';
  const pendingKey = 'corner:browse:pending:v1';
  const allowedPage = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:collections|products|search|pages|blogs|cart)(?:\/|$)/i;
  const safeUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (!allowedPage.test(url.pathname) && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(url.pathname)) return null;
      return url;
    } catch { return null; }
  };
  const productKey = value => {
    const url = safeUrl(value);
    return url?.pathname.match(/\/products\/([^/]+)/)?.[1] || null;
  };
  const currentUrl = () => location.pathname + location.search + location.hash;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  if (!safeUrl(location.href)) return;
  let records = read(storageKey) || [];
  if (!Array.isArray(records)) records = [];
  records = records.filter(record => record && Date.now() - record.time < 7200000).slice(-30);
  const navType = performance.getEntriesByType('navigation')[0]?.type;
  const saved = history.state?.[stateKey];
  const pending = read(pendingKey);
  const referrer = document.referrer ? safeUrl(document.referrer) : null;
  let entry = saved && safeUrl(saved.url)?.pathname === location.pathname ? saved : null;
  if (!entry && navType === 'reload') {
    entry = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname) || null;
  }
  if (!entry && /\/pages\/member-line-benefits\/?$/.test(location.pathname) && new URLSearchParams(location.search).get('corner_coupon_return') === '1') {
    const beforeLogin = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname && safeUrl(record.previous));
    if (beforeLogin) entry = { ...beforeLogin, canBack: false };
  }
  if (!entry) {
    const incoming = navType !== 'back_forward' && navType !== 'reload' && pending &&
      Date.now() - pending.time < 120000 && safeUrl(pending.to)?.pathname === location.pathname && safeUrl(pending.from);
    entry = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
      url: currentUrl(),
      previous: incoming ? pending.from : referrer && referrer.pathname !== location.pathname ? referrer.pathname + referrer.search + referrer.hash : null,
      canBack: Boolean(incoming && history.length > 1),
      time: Date.now()
    };
  }
  remove(pendingKey);
  const persist = () => {
    entry.url = currentUrl();
    entry.time = Date.now();
    records = records.filter(record => record.id !== entry.id).slice(-29);
    records.push(entry);
    write(storageKey, records);
    try { history.replaceState({ ...history.state, [stateKey]: entry }, '', location.href); } catch {}
  };
  const anchorCard = () => {
    if (!entry.anchor) return null;
    const link = Array.from(document.querySelectorAll('main a[href]')).find(item => productKey(item.href) === entry.anchor.product);
    return link?.closest('.sf__pcard, .product-item') || link;
  };
  const snapshot = selectedLink => {
    const card = selectedLink?.closest?.('.sf__pcard, .product-item') || anchorCard();
    if (card?.getBoundingClientRect) {
      entry.anchor = { product: selectedLink ? productKey(selectedLink.href) : entry.anchor.product, top: card.getBoundingClientRect().top };
    }
    entry.x = window.scrollX;
    entry.y = window.scrollY;
    entry.rails = Array.from(document.querySelectorAll('[data-corner-rail-track][id]'), track => ({ id: track.id, x: track.scrollLeft }));
    persist();
  };
  const configureBack = () => {
    const previous = safeUrl(entry.previous || '');
    document.querySelectorAll('[data-corner-back]').forEach(link => {
      if (entry.previous && previous && previous.href !== location.href) {
        link.href = previous.pathname + previous.search + previous.hash;
        const label = link.querySelector('span');
        if (label && link.dataset.backLabel) label.textContent = link.dataset.backLabel;
        const parent = document.querySelector('[data-corner-parent]');
        if (parent && safeUrl(parent.href)?.pathname === previous.pathname) parent.href = link.href;
      }
    });
  };
  let restoring = false;
  let stopRestore = () => {};
  const restore = () => {
    if (!Number.isFinite(entry.y)) return;
    stopRestore();
    restoring = true;
    const controller = new AbortController();
    const started = Date.now();
    let timer;
    stopRestore = () => { clearTimeout(timer); controller.abort(); restoring = false; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => window.addEventListener(type, stopRestore, { once: true, passive: true, signal: controller.signal }));
    const apply = () => {
      if (!restoring) return;
      for (const rail of entry.rails || []) {
        const track = document.getElementById(rail.id);
        if (track) track.scrollLeft = rail.x;
      }
      const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      const card = anchorCard();
      const targetY = card ? Math.max(0, window.scrollY + card.getBoundingClientRect().top - entry.anchor.top) : entry.y;
      if (height - innerHeight >= targetY - 2) window.scrollTo({ left: entry.x || 0, top: targetY, behavior: 'instant' });
      if (Date.now() - started < 2500) timer = setTimeout(apply, 100);
      else stopRestore();
    };
    apply();
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (link.matches('[data-corner-back]')) {
      if (entry.canBack && history.length > 1 && safeUrl(entry.previous)) {
        event.preventDefault();
        snapshot();
        history.back();
      }
      return;
    }
    const destination = safeUrl(link.href);
    if (!destination || destination.pathname === location.pathname) return;
    if (!productKey(link.href) && !/\/(?:cart|pages\/member-line-benefits)\/?$/.test(destination.pathname)) return;
    entry.reopenCart = Boolean(link.closest('m-cart-drawer.m-cart-drawer--active'));
    snapshot(productKey(link.href) ? link : null);
    write(pendingKey, { from: currentUrl(), to: link.href, time: Date.now() });
  });
  window.addEventListener('pagehide', () => { if (!restoring) snapshot(); stopRestore(); });
  window.addEventListener('pageshow', event => {
    configureBack();
    if (event.persisted || navType === 'back_forward') {
      restore();
      if (entry.reopenCart) {
        entry.reopenCart = false;
        customElements.whenDefined('m-cart-drawer').then(() => document.querySelector('m-cart-drawer')?.open());
      }
    }
    else persist();
  });
  window.addEventListener('popstate', event => {
    stopRestore();
    const next = event.state?.[stateKey];
    if (next && next.url === currentUrl()) {
      entry = next;
      configureBack();
      restore();
    }
  });
  configureBack();
  persist();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corner-coupon-journey"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => {
    document.querySelectorAll('[data-corner-coupon-form]').forEach(form => {
      if (form.dataset.ready) return;
      const input = form.querySelector('[data-corner-coupon-code]');
      if (!input) return;
      form.dataset.ready = 'true';
      form.hidden = false;
      input.addEventListener('input', () => input.setCustomValidity(''));
      form.addEventListener('submit', event => {
        const code = input.value.trim();
        input.value = code;
        if (!code) {
          event.preventDefault();
          input.setCustomValidity(input.dataset.emptyMessage);
          input.reportValidity();
          return;
        }
        // Shopify checks eligibility; the native redirect still works without local storage.
        form.action = '/discount/' + encodeURIComponent(code);
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corner-coupon-price"] && !Shopify.designMode) return;
  try {
    (() => {
    const attached = new WeakSet();
    const formatYen = value => '¥' + new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 0 }).format(value);
    function attach(root) {
      const blocks = root.matches?.('[data-corner-coupon]') ? [root] : root.querySelectorAll?.('[data-corner-coupon]') || [];
      for (const block of blocks) {
        if (attached.has(block)) continue;
        const wrapper = block.closest('.f-price');
        if (!wrapper) continue;
        attached.add(block);
        const sync = () => {
          const source = wrapper.classList.contains('f-price--on-sale') ? wrapper.querySelector('.f-price__sale .f-price-item--sale') : wrapper.querySelector('.f-price__regular .f-price-item--regular');
          const raw = source?.textContent?.match(/[0-9][0-9,]*(?:\.[0-9]+)?/);
          const yen = raw ? Number(raw[0].replaceAll(',', '')) : NaN;
          block.hidden = wrapper.classList.contains('f-price--sold-out') || !Number.isFinite(yen) || yen <= 0;
          if (block.hidden) return;
          const saved = Math.floor(yen * 5 / 100);
          const amount = block.querySelector('[data-corner-coupon-amount]');
          const saving = block.querySelector('[data-corner-coupon-saved]');
          if (amount.textContent !== formatYen(yen - saved)) amount.textContent = formatYen(yen - saved);
          if (saving.textContent !== formatYen(saved)) saving.textContent = formatYen(saved);
        };
        sync();
        new MutationObserver(sync).observe(wrapper, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['class'] });
      }
    }
    function start() {
      attach(document);
      const root = document.getElementById('MainContent') || document.body;
      new MutationObserver(records => {
        for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) attach(node);
      }).observe(root, { childList:true, subtree:true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true }); else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corner-home-product-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('corner-product-rail')) {
  customElements.define('corner-product-rail', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.attach());
    }
    attach() {
      const track = this.querySelector('[data-corner-rail-track]');
      const previous = this.querySelector('[data-rail-prev]');
      const next = this.querySelector('[data-rail-next]');
      const controls = this.querySelector('.corner-product-rail__controls');
      if (!track || !previous || !next || !controls) return;
      this.events?.abort();
      this.resize?.disconnect();
      this.items?.disconnect();
      this.events = new AbortController();
      const signal = this.events.signal;
      const update = () => {
        const end = Math.max(0, track.scrollWidth - track.clientWidth);
        const position = Math.max(0, Math.abs(track.scrollLeft));
        previous.disabled = position <= 1;
        next.disabled = position >= end - 1;
        this.toggleAttribute('data-no-overflow', end <= 1);
      };
      const move = step => {
        const style = getComputedStyle(track);
        const item = track.firstElementChild;
        const width = item?.getBoundingClientRect().width || track.clientWidth;
        const direction = style.direction === 'rtl' ? -1 : 1;
        track.scrollBy({
          left: step * direction * (width + (parseFloat(style.columnGap) || 0)),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      };
      previous.addEventListener('click', () => move(-1), { signal });
      next.addEventListener('click', () => move(1), { signal });
      track.addEventListener('scroll', update, { passive: true, signal });
      track.addEventListener('keydown', event => {
        if (event.target !== track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        move(event.key === 'ArrowRight' ? 1 : -1);
      }, { signal });
      controls.hidden = false;
      this.resize = new ResizeObserver(update);
      this.resize.observe(track);
      this.items = new MutationObserver(update);
      this.items.observe(track, { childList:true });
      update();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.resize?.disconnect();
      this.items?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corner-modelnav-preview"] && !Shopify.designMode) return;
  try {
    (() => {
  const stateKey = 'cornerBrowse';
  const storageKey = 'corner:browse:v1';
  const pendingKey = 'corner:browse:pending:v1';
  const allowedPage = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:collections|products|search|pages|blogs|cart)(?:\/|$)/i;
  const safeUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (!allowedPage.test(url.pathname) && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(url.pathname)) return null;
      return url;
    } catch { return null; }
  };
  const productKey = value => {
    const url = safeUrl(value);
    return url?.pathname.match(/\/products\/([^/]+)/)?.[1] || null;
  };
  const currentUrl = () => location.pathname + location.search + location.hash;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  if (!safeUrl(location.href)) return;
  let records = read(storageKey) || [];
  if (!Array.isArray(records)) records = [];
  records = records.filter(record => record && Date.now() - record.time < 7200000).slice(-30);
  const navType = performance.getEntriesByType('navigation')[0]?.type;
  const saved = history.state?.[stateKey];
  const pending = read(pendingKey);
  const referrer = document.referrer ? safeUrl(document.referrer) : null;
  let entry = saved && safeUrl(saved.url)?.pathname === location.pathname ? saved : null;
  if (!entry && navType === 'reload') {
    entry = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname) || null;
  }
  if (!entry && /\/pages\/member-line-benefits\/?$/.test(location.pathname) && new URLSearchParams(location.search).get('corner_coupon_return') === '1') {
    const beforeLogin = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname && safeUrl(record.previous));
    if (beforeLogin) entry = { ...beforeLogin, canBack: false };
  }
  if (!entry) {
    const incoming = navType !== 'back_forward' && navType !== 'reload' && pending &&
      Date.now() - pending.time < 120000 && safeUrl(pending.to)?.pathname === location.pathname && safeUrl(pending.from);
    entry = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
      url: currentUrl(),
      previous: incoming ? pending.from : referrer && referrer.pathname !== location.pathname ? referrer.pathname + referrer.search + referrer.hash : null,
      canBack: Boolean(incoming && history.length > 1),
      time: Date.now()
    };
  }
  remove(pendingKey);
  const persist = () => {
    entry.url = currentUrl();
    entry.time = Date.now();
    records = records.filter(record => record.id !== entry.id).slice(-29);
    records.push(entry);
    write(storageKey, records);
    try { history.replaceState({ ...history.state, [stateKey]: entry }, '', location.href); } catch {}
  };
  const anchorCard = () => {
    if (!entry.anchor) return null;
    const link = Array.from(document.querySelectorAll('main a[href]')).find(item => productKey(item.href) === entry.anchor.product);
    return link?.closest('.sf__pcard, .product-item') || link;
  };
  const snapshot = selectedLink => {
    const card = selectedLink?.closest?.('.sf__pcard, .product-item') || anchorCard();
    if (card?.getBoundingClientRect) {
      entry.anchor = { product: selectedLink ? productKey(selectedLink.href) : entry.anchor.product, top: card.getBoundingClientRect().top };
    }
    entry.x = window.scrollX;
    entry.y = window.scrollY;
    entry.rails = Array.from(document.querySelectorAll('[data-corner-rail-track][id]'), track => ({ id: track.id, x: track.scrollLeft }));
    persist();
  };
  const configureBack = () => {
    const previous = safeUrl(entry.previous || '');
    document.querySelectorAll('[data-corner-back]').forEach(link => {
      if (entry.previous && previous && previous.href !== location.href) {
        link.href = previous.pathname + previous.search + previous.hash;
        const label = link.querySelector('span');
        if (label && link.dataset.backLabel) label.textContent = link.dataset.backLabel;
        const parent = document.querySelector('[data-corner-parent]');
        if (parent && safeUrl(parent.href)?.pathname === previous.pathname) parent.href = link.href;
      }
    });
  };
  let restoring = false;
  let stopRestore = () => {};
  const restore = () => {
    if (!Number.isFinite(entry.y)) return;
    stopRestore();
    restoring = true;
    const controller = new AbortController();
    const started = Date.now();
    let timer;
    stopRestore = () => { clearTimeout(timer); controller.abort(); restoring = false; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => window.addEventListener(type, stopRestore, { once: true, passive: true, signal: controller.signal }));
    const apply = () => {
      if (!restoring) return;
      for (const rail of entry.rails || []) {
        const track = document.getElementById(rail.id);
        if (track) track.scrollLeft = rail.x;
      }
      const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      const card = anchorCard();
      const targetY = card ? Math.max(0, window.scrollY + card.getBoundingClientRect().top - entry.anchor.top) : entry.y;
      if (height - innerHeight >= targetY - 2) window.scrollTo({ left: entry.x || 0, top: targetY, behavior: 'instant' });
      if (Date.now() - started < 2500) timer = setTimeout(apply, 100);
      else stopRestore();
    };
    apply();
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (link.matches('[data-corner-back]')) {
      if (entry.canBack && history.length > 1 && safeUrl(entry.previous)) {
        event.preventDefault();
        snapshot();
        history.back();
      }
      return;
    }
    const destination = safeUrl(link.href);
    if (!destination || destination.pathname === location.pathname) return;
    if (!productKey(link.href) && !/\/(?:cart|pages\/member-line-benefits)\/?$/.test(destination.pathname)) return;
    entry.reopenCart = Boolean(link.closest('m-cart-drawer.m-cart-drawer--active'));
    snapshot(productKey(link.href) ? link : null);
    write(pendingKey, { from: currentUrl(), to: link.href, time: Date.now() });
  });
  window.addEventListener('pagehide', () => { if (!restoring) snapshot(); stopRestore(); });
  window.addEventListener('pageshow', event => {
    configureBack();
    if (event.persisted || navType === 'back_forward') {
      restore();
      if (entry.reopenCart) {
        entry.reopenCart = false;
        customElements.whenDefined('m-cart-drawer').then(() => document.querySelector('m-cart-drawer')?.open());
      }
    }
    else persist();
  });
  window.addEventListener('popstate', event => {
    stopRestore();
    const next = event.state?.[stateKey];
    if (next && next.url === currentUrl()) {
      entry = next;
      configureBack();
      restore();
    }
  });
  configureBack();
  persist();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corner-product-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const stateKey = 'cornerBrowse';
  const storageKey = 'corner:browse:v1';
  const pendingKey = 'corner:browse:pending:v1';
  const allowedPage = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:collections|products|search|pages|blogs|cart)(?:\/|$)/i;
  const safeUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (!allowedPage.test(url.pathname) && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(url.pathname)) return null;
      return url;
    } catch { return null; }
  };
  const productKey = value => {
    const url = safeUrl(value);
    return url?.pathname.match(/\/products\/([^/]+)/)?.[1] || null;
  };
  const currentUrl = () => location.pathname + location.search + location.hash;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  if (!safeUrl(location.href)) return;
  let records = read(storageKey) || [];
  if (!Array.isArray(records)) records = [];
  records = records.filter(record => record && Date.now() - record.time < 7200000).slice(-30);
  const navType = performance.getEntriesByType('navigation')[0]?.type;
  const saved = history.state?.[stateKey];
  const pending = read(pendingKey);
  const referrer = document.referrer ? safeUrl(document.referrer) : null;
  let entry = saved && safeUrl(saved.url)?.pathname === location.pathname ? saved : null;
  if (!entry && navType === 'reload') {
    entry = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname) || null;
  }
  if (!entry && /\/pages\/member-line-benefits\/?$/.test(location.pathname) && new URLSearchParams(location.search).get('corner_coupon_return') === '1') {
    const beforeLogin = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname && safeUrl(record.previous));
    if (beforeLogin) entry = { ...beforeLogin, canBack: false };
  }
  if (!entry) {
    const incoming = navType !== 'back_forward' && navType !== 'reload' && pending &&
      Date.now() - pending.time < 120000 && safeUrl(pending.to)?.pathname === location.pathname && safeUrl(pending.from);
    entry = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
      url: currentUrl(),
      previous: incoming ? pending.from : referrer && referrer.pathname !== location.pathname ? referrer.pathname + referrer.search + referrer.hash : null,
      canBack: Boolean(incoming && history.length > 1),
      time: Date.now()
    };
  }
  remove(pendingKey);
  const persist = () => {
    entry.url = currentUrl();
    entry.time = Date.now();
    records = records.filter(record => record.id !== entry.id).slice(-29);
    records.push(entry);
    write(storageKey, records);
    try { history.replaceState({ ...history.state, [stateKey]: entry }, '', location.href); } catch {}
  };
  const anchorCard = () => {
    if (!entry.anchor) return null;
    const link = Array.from(document.querySelectorAll('main a[href]')).find(item => productKey(item.href) === entry.anchor.product);
    return link?.closest('.sf__pcard, .product-item') || link;
  };
  const snapshot = selectedLink => {
    const card = selectedLink?.closest?.('.sf__pcard, .product-item') || anchorCard();
    if (card?.getBoundingClientRect) {
      entry.anchor = { product: selectedLink ? productKey(selectedLink.href) : entry.anchor.product, top: card.getBoundingClientRect().top };
    }
    entry.x = window.scrollX;
    entry.y = window.scrollY;
    entry.rails = Array.from(document.querySelectorAll('[data-corner-rail-track][id]'), track => ({ id: track.id, x: track.scrollLeft }));
    persist();
  };
  const configureBack = () => {
    const previous = safeUrl(entry.previous || '');
    document.querySelectorAll('[data-corner-back]').forEach(link => {
      if (entry.previous && previous && previous.href !== location.href) {
        link.href = previous.pathname + previous.search + previous.hash;
        const label = link.querySelector('span');
        if (label && link.dataset.backLabel) label.textContent = link.dataset.backLabel;
        const parent = document.querySelector('[data-corner-parent]');
        if (parent && safeUrl(parent.href)?.pathname === previous.pathname) parent.href = link.href;
      }
    });
  };
  let restoring = false;
  let stopRestore = () => {};
  const restore = () => {
    if (!Number.isFinite(entry.y)) return;
    stopRestore();
    restoring = true;
    const controller = new AbortController();
    const started = Date.now();
    let timer;
    stopRestore = () => { clearTimeout(timer); controller.abort(); restoring = false; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => window.addEventListener(type, stopRestore, { once: true, passive: true, signal: controller.signal }));
    const apply = () => {
      if (!restoring) return;
      for (const rail of entry.rails || []) {
        const track = document.getElementById(rail.id);
        if (track) track.scrollLeft = rail.x;
      }
      const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      const card = anchorCard();
      const targetY = card ? Math.max(0, window.scrollY + card.getBoundingClientRect().top - entry.anchor.top) : entry.y;
      if (height - innerHeight >= targetY - 2) window.scrollTo({ left: entry.x || 0, top: targetY, behavior: 'instant' });
      if (Date.now() - started < 2500) timer = setTimeout(apply, 100);
      else stopRestore();
    };
    apply();
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (link.matches('[data-corner-back]')) {
      if (entry.canBack && history.length > 1 && safeUrl(entry.previous)) {
        event.preventDefault();
        snapshot();
        history.back();
      }
      return;
    }
    const destination = safeUrl(link.href);
    if (!destination || destination.pathname === location.pathname) return;
    if (!productKey(link.href) && !/\/(?:cart|pages\/member-line-benefits)\/?$/.test(destination.pathname)) return;
    entry.reopenCart = Boolean(link.closest('m-cart-drawer.m-cart-drawer--active'));
    snapshot(productKey(link.href) ? link : null);
    write(pendingKey, { from: currentUrl(), to: link.href, time: Date.now() });
  });
  window.addEventListener('pagehide', () => { if (!restoring) snapshot(); stopRestore(); });
  window.addEventListener('pageshow', event => {
    configureBack();
    if (event.persisted || navType === 'back_forward') {
      restore();
      if (entry.reopenCart) {
        entry.reopenCart = false;
        customElements.whenDefined('m-cart-drawer').then(() => document.querySelector('m-cart-drawer')?.open());
      }
    }
    else persist();
  });
  window.addEventListener('popstate', event => {
    stopRestore();
    const next = event.state?.[stateKey];
    if (next && next.url === currentUrl()) {
      entry = next;
      configureBack();
      restore();
    }
  });
  configureBack();
  persist();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["corner-repair-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const stateKey = 'cornerBrowse';
  const storageKey = 'corner:browse:v1';
  const pendingKey = 'corner:browse:pending:v1';
  const allowedPage = /^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(?:collections|products|search|pages|blogs|cart)(?:\/|$)/i;
  const safeUrl = value => {
    try {
      const url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      if (!allowedPage.test(url.pathname) && !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(url.pathname)) return null;
      return url;
    } catch { return null; }
  };
  const productKey = value => {
    const url = safeUrl(value);
    return url?.pathname.match(/\/products\/([^/]+)/)?.[1] || null;
  };
  const currentUrl = () => location.pathname + location.search + location.hash;
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch {} };
  if (!safeUrl(location.href)) return;
  let records = read(storageKey) || [];
  if (!Array.isArray(records)) records = [];
  records = records.filter(record => record && Date.now() - record.time < 7200000).slice(-30);
  const navType = performance.getEntriesByType('navigation')[0]?.type;
  const saved = history.state?.[stateKey];
  const pending = read(pendingKey);
  const referrer = document.referrer ? safeUrl(document.referrer) : null;
  let entry = saved && safeUrl(saved.url)?.pathname === location.pathname ? saved : null;
  if (!entry && navType === 'reload') {
    entry = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname) || null;
  }
  if (!entry && /\/pages\/member-line-benefits\/?$/.test(location.pathname) && new URLSearchParams(location.search).get('corner_coupon_return') === '1') {
    const beforeLogin = records.findLast(record => safeUrl(record.url)?.pathname === location.pathname && safeUrl(record.previous));
    if (beforeLogin) entry = { ...beforeLogin, canBack: false };
  }
  if (!entry) {
    const incoming = navType !== 'back_forward' && navType !== 'reload' && pending &&
      Date.now() - pending.time < 120000 && safeUrl(pending.to)?.pathname === location.pathname && safeUrl(pending.from);
    entry = {
      id: Date.now().toString(36) + Math.random().toString(36).slice(2, 8),
      url: currentUrl(),
      previous: incoming ? pending.from : referrer && referrer.pathname !== location.pathname ? referrer.pathname + referrer.search + referrer.hash : null,
      canBack: Boolean(incoming && history.length > 1),
      time: Date.now()
    };
  }
  remove(pendingKey);
  const persist = () => {
    entry.url = currentUrl();
    entry.time = Date.now();
    records = records.filter(record => record.id !== entry.id).slice(-29);
    records.push(entry);
    write(storageKey, records);
    try { history.replaceState({ ...history.state, [stateKey]: entry }, '', location.href); } catch {}
  };
  const anchorCard = () => {
    if (!entry.anchor) return null;
    const link = Array.from(document.querySelectorAll('main a[href]')).find(item => productKey(item.href) === entry.anchor.product);
    return link?.closest('.sf__pcard, .product-item') || link;
  };
  const snapshot = selectedLink => {
    const card = selectedLink?.closest?.('.sf__pcard, .product-item') || anchorCard();
    if (card?.getBoundingClientRect) {
      entry.anchor = { product: selectedLink ? productKey(selectedLink.href) : entry.anchor.product, top: card.getBoundingClientRect().top };
    }
    entry.x = window.scrollX;
    entry.y = window.scrollY;
    entry.rails = Array.from(document.querySelectorAll('[data-corner-rail-track][id]'), track => ({ id: track.id, x: track.scrollLeft }));
    persist();
  };
  const configureBack = () => {
    const previous = safeUrl(entry.previous || '');
    document.querySelectorAll('[data-corner-back]').forEach(link => {
      if (entry.previous && previous && previous.href !== location.href) {
        link.href = previous.pathname + previous.search + previous.hash;
        const label = link.querySelector('span');
        if (label && link.dataset.backLabel) label.textContent = link.dataset.backLabel;
        const parent = document.querySelector('[data-corner-parent]');
        if (parent && safeUrl(parent.href)?.pathname === previous.pathname) parent.href = link.href;
      }
    });
  };
  let restoring = false;
  let stopRestore = () => {};
  const restore = () => {
    if (!Number.isFinite(entry.y)) return;
    stopRestore();
    restoring = true;
    const controller = new AbortController();
    const started = Date.now();
    let timer;
    stopRestore = () => { clearTimeout(timer); controller.abort(); restoring = false; };
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(type => window.addEventListener(type, stopRestore, { once: true, passive: true, signal: controller.signal }));
    const apply = () => {
      if (!restoring) return;
      for (const rail of entry.rails || []) {
        const track = document.getElementById(rail.id);
        if (track) track.scrollLeft = rail.x;
      }
      const height = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      const card = anchorCard();
      const targetY = card ? Math.max(0, window.scrollY + card.getBoundingClientRect().top - entry.anchor.top) : entry.y;
      if (height - innerHeight >= targetY - 2) window.scrollTo({ left: entry.x || 0, top: targetY, behavior: 'instant' });
      if (Date.now() - started < 2500) timer = setTimeout(apply, 100);
      else stopRestore();
    };
    apply();
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (link.matches('[data-corner-back]')) {
      if (entry.canBack && history.length > 1 && safeUrl(entry.previous)) {
        event.preventDefault();
        snapshot();
        history.back();
      }
      return;
    }
    const destination = safeUrl(link.href);
    if (!destination || destination.pathname === location.pathname) return;
    if (!productKey(link.href) && !/\/(?:cart|pages\/member-line-benefits)\/?$/.test(destination.pathname)) return;
    entry.reopenCart = Boolean(link.closest('m-cart-drawer.m-cart-drawer--active'));
    snapshot(productKey(link.href) ? link : null);
    write(pendingKey, { from: currentUrl(), to: link.href, time: Date.now() });
  });
  window.addEventListener('pagehide', () => { if (!restoring) snapshot(); stopRestore(); });
  window.addEventListener('pageshow', event => {
    configureBack();
    if (event.persisted || navType === 'back_forward') {
      restore();
      if (entry.reopenCart) {
        entry.reopenCart = false;
        customElements.whenDefined('m-cart-drawer').then(() => document.querySelector('m-cart-drawer')?.open());
      }
    }
    else persist();
  });
  window.addEventListener('popstate', event => {
    stopRestore();
    const next = event.state?.[stateKey];
    if (next && next.url === currentUrl()) {
      entry = next;
      configureBack();
      restore();
    }
  });
  configureBack();
  persist();
})();
  } catch(e) { console.error(e); }
})();

})();
